/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramAvailableFeaturesControllerGetFeatureByKeyQueryResponse,
  TelegramAvailableFeaturesControllerGetFeatureByKeyPathParams,
} from '../types/TelegramAvailableFeaturesControllerGetFeatureByKey.ts';

function getTelegramAvailableFeaturesGetFeatureByKeyUrl(
  key: TelegramAvailableFeaturesControllerGetFeatureByKeyPathParams['key'],
) {
  const res = { method: 'GET', url: `/api/telegram/available-features/${key}` as const };
  return res;
}

/**
 * {@link /api/telegram/available-features/:key}
 */
export async function telegramAvailableFeaturesGetFeatureByKey(
  key: TelegramAvailableFeaturesControllerGetFeatureByKeyPathParams['key'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    TelegramAvailableFeaturesControllerGetFeatureByKeyQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({ method: 'GET', url: getTelegramAvailableFeaturesGetFeatureByKeyUrl(key).url.toString(), ...requestConfig });
  return res.data;
}
